<template>
  <div>
    <select-available-date
      v-model="selectedDate"
      :selected-date="apiResponse.selectedDate"
      :available-dates="apiResponse.availableDates"
      :label="$t('Common.Date.Selector.Label')"
      :placeholder="$t('Common.Date.Selector.Placeholder')"
      @change="onDateChange"
    />
  </div>
</template>

<script>
import SelectAvailableDate from './SelectAvailableDate'

export default {
  name      : 'PortfolioDateSelector',
  components: { SelectAvailableDate },
  directives: {},
  mixins    : [],
  props     : {
    apiResponse: {
      type   : Object,
      default: () => ({
        selectedDate  : '',
        availableDates: []
      })
    }
  },
  dataStore: {},
  enums    : {},
  dataModel: null,
  data () {
    return {
      selectedDate: ''
    }
  },
  computed: {},
  watch   : {
    'apiResponse.selectedDate': {
      handler (newVal) {
        if (newVal) {
          this.selectedDate = newVal
        }
      },
      immediate: true
    }
  },
  beforeCreate () {},
  created () {},
  beforeMount () {},
  mounted () {},
  beforeUpdate () {},
  updated () {},
  beforeDestroy () {},
  destroyed () {},
  methods: {
    onDateChange (newDate) {
      // Emit the change event to parent component
      this.$emit('date-change', newDate)

      // You can also trigger an API call here to fetch new data
      this.fetchPortfolioData(newDate)
    },

    fetchPortfolioData (date) {
      // Example API call with the selected date
      // Replace with your actual API call
      this.$emit('fetch-data', { selectedDate: date })
    }
  }
}
</script>

<style scoped>
/* Add any additional styling here */
</style>
